import { environment } from "@environment";

export function isDae(env: string): boolean {
    return environment.tenants[0] === env
}

export function isLto(env: string): boolean {
    return environment.tenants[1] === env
}